(function() {
  'use strict';

  angular
    .module('admin.explore.custombundle.service', [])
    .factory('ExploreCustomBundleService', ExploreCustomBundleService);

  /** @ngInject */
  function ExploreCustomBundleService($http, $q, API) {

    function list(t, start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/bundle_lists?t=' + t + '&start=' + start + '&limit=' + limit + '&sort=id-desc')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listAll(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/bundle_lists')
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function listBlbs(id, start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/bundle_lists/' + id + '/blbs?start=' + start + '&limit=' + limit + '&sort=n-asc')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function get(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/bundle_lists/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function create(model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/bundle_lists', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function createBlbs(id, model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/bundle_lists/' + id + '/blbs', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/bundle_lists/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateBlbs(parentId, id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/bundle_lists/' + parentId + '/blbs/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/bundle_lists/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeBlbs(parentId, id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/bundle_lists/' + parentId + '/blbs/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
       list: list,
       listAll: listAll,
       listBlbs: listBlbs,
       get: get,
       create: create,
       createBlbs: createBlbs,
       updateBlbs: updateBlbs,
       update: update,
       remove: remove,
       removeBlbs: removeBlbs,
    };

  }

})();
